/* eslint-disable react/destructuring-assignment */
import React, { useContext } from 'react';
import { styled } from '@abyss/web/tools/styled';
import { useModel } from '@abyss/ui/form/hooks/useModel';
import { Button } from 'src/common/Button';
import { storage } from '@abyss/ui/tools/storage';
import { Heading } from '@abyss/web/ui/Heading';
import { config } from '@abyss/ui/tools/config';
import { useAdminContext } from 'src/hooks/useAdminContext';
import { AlertContext } from 'src/tools/AlertContext';
import { FindForm } from 'src/common/FindForm';

const ContinueButton = styled('div', {
  margin: '20px 100px 20px 0',
  float: 'right',
});

const StyledHeading = styled(Heading, {
  fontWeight: 'bold',
});

const ConfirmUserTitle = styled('h3', {
  marginTop: 20,
});

const Table = styled('table', {
  '& th': {
    fontWeight: 'bold',
  },
  '& th, & td': {
    minWidth: 200,
    textAlign: 'left',
  },
});

export const UHCInsightsUser = () => {
  const modelName = 'emulation-uhc-insights-user';
  const emulationModel = useModel(modelName, {});
  const emulatedUser = emulationModel.emulatedUser || {};
  const errorContext = useContext(AlertContext);

  const [adminResult, setAdminContext] = useAdminContext({
    onCompleted: () => {
      const redirect = storage.session.get('redirect');
      window.location = decodeURIComponent(redirect || config('SDE_URL'));
    },
    onError: error => {
      errorContext.addAlert(error);
    },
  });

  const handleContinue = () => {
    setAdminContext({
      variables: {
        role: 'uhc-insights-user',
        id: emulatedUser.uuid,
      },
    });
  };

  return (
    <React.Fragment>
      <StyledHeading>UHC Insights User</StyledHeading>
      <p data-testid="uhc-insights-user-header">
        The ID you signed in with has UHC Insights user access. Please enter the
        One Healthcare ID of the user you want to sign in as.
      </p>
      <FindForm modelName={modelName} />
      <If condition={emulatedUser.uuid}>
        <ConfirmUserTitle>Confirm User</ConfirmUserTitle>
        <p>
          Below is the name and email address associated with the One Healthcare
          ID you entered. If correct, click continue.
        </p>
        <Table>
          <tbody>
            <tr>
              <th>Name</th>
              <th>Email Address</th>
            </tr>
            <tr>
              <td>
                {emulatedUser.firstName} {emulatedUser.lastName}
              </td>
              <td>{emulatedUser.email}</td>
            </tr>
          </tbody>
        </Table>
      </If>
      <ContinueButton>
        <Button
          data-testid="continue-button"
          size="size700"
          isLoading={adminResult.isLoading}
          isDisabled={!emulatedUser.uuid}
          onClick={handleContinue}
        >
          Continue
        </Button>
      </ContinueButton>
    </React.Fragment>
  );
};
